__turbopack_context__.v({
  "flex": "grid-layout-module__OQOvsq__flex",
  "grid": "grid-layout-module__OQOvsq__grid",
});
